import { Link, Stack, Typography, useTheme } from '@mui/material';
import { useMemo } from 'react';
import Markdown from 'react-markdown';

import { useBrowser } from '@frontend/hooks';

export interface MarkdownDisplayProps {
  markdown: string | undefined;
}

export const MarkdownDisplay = (props: MarkdownDisplayProps) => {
  const theme = useTheme();
  const { open } = useBrowser();

  const formattedMarkdown = useMemo(() => {
    return props.markdown?.replaceAll('\n', '  \n') ?? '';
  }, [props.markdown]);

  const constructRefUrl = (url: string) => {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }

    return `https://${url}`;
  };

  return (
    <Stack
      direction="column"
      spacing={1.5}
      sx={{
        'ul, ol': {
          paddingInlineStart: theme.spacing(2),
          marginBlockEnd: 0,
          marginBlockStart: 0,
        },
        li: {
          ...theme.typography.body2,
          color: theme.palette.text.secondary,
        },
      }}
    >
      <Markdown
        components={{
          a: (ref) => (
            <Link
              sx={{ cursor: 'pointer' }}
              href={ref.href ? constructRefUrl(ref.href) : undefined}
              target="_blank"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                if (ref.href) {
                  open({ url: constructRefUrl(ref.href) });
                }
              }}
            >
              {ref.children}
            </Link>
          ),
          p: ({ children }) => (
            <Typography variant="body2" color={theme.palette.text.secondary}>
              {children}
            </Typography>
          ),
        }}
      >
        {formattedMarkdown}
      </Markdown>
    </Stack>
  );
};
